// extracted by mini-css-extract-plugin
export var icon = "ImpactIcons-module--icon--qs6L3";
export var impactContainer = "ImpactIcons-module--impactContainer--LXLVU";
export var svg = "ImpactIcons-module--svg--sQpBK";